module.exports = __webpack_public_path__ + "./huichen_b839f8ed405e34ada201ea389f26263e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/huichen.png
// module id = 459
// module chunks = 0